import React, { useMemo, useState } from "react";

function ContactForm({ endpointUrl = "" }) {
  const formStartedAt = useMemo(() => Date.now(), []);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [contactWebsite, setContactWebsite] = useState("");

  const [status, setStatus] = useState("idle"); // idle | sending | success | error
  const [errorText, setErrorText] = useState("");

  const isValid =
    name.trim().length >= 2 &&
    email.trim().includes("@") &&
    message.trim().length >= 5 &&
    endpointUrl.trim().length > 0;

  const resetStatusIfNeeded = () => {
    if (status === "success" || status === "error") {
      setStatus("idle");
      setErrorText("");
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setErrorText("");

  if (!isValid || status === "sending") return;

  setStatus("sending");

  let timeout = null;

  try {
    const controller = new AbortController();
    timeout = setTimeout(() => controller.abort(), 12000);

    const res = await fetch(endpointUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      signal: controller.signal,
      body: JSON.stringify({
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
        website: contactWebsite,
        formStartedAt,
      }),
    });

    let data = {};
    try {
      data = await res.json();
    } catch {
      data = {};
    }

    if (!res.ok || data?.ok !== true) {
      setErrorText(
        data?.error || "Senden fehlgeschlagen. Bitte versuche es später erneut."
      );
      setStatus("error");
      return;
    }

    setStatus("success");
    setName("");
    setEmail("");
    setMessage("");
    setContactWebsite("");
  } catch (error) {
    setErrorText(
      error?.name === "AbortError"
        ? "Die Anfrage dauert zu lange. Bitte versuche es später erneut."
        : "Netzwerkfehler. Bitte versuche es später erneut."
    );
    setStatus("error");
  } finally {
    if (timeout) clearTimeout(timeout);
  }
};

  return (
    <div>
      <h3>Kontakt</h3>

      <form onSubmit={handleSubmit} className="contact-form">
        <label className="contact-label">
          Name
          <input
            type="text"
            className="contact-input"
            value={name}
            onChange={(e) => {
              resetStatusIfNeeded();
              setName(e.target.value);
            }}
            autoComplete="name"
            placeholder="Dein Name"
            required
          />
        </label>

        <label className="contact-label">
          E-Mail
          <input
            type="email"
            className="contact-input"
            value={email}
            onChange={(e) => {
              resetStatusIfNeeded();
              setEmail(e.target.value);
            }}
            autoComplete="email"
            placeholder="deinname@mail.de"
            required
          />
        </label>

        <label className="contact-label">
          Nachricht
          <textarea
            className="contact-textarea"
            value={message}
            onChange={(e) => {
              resetStatusIfNeeded();
              setMessage(e.target.value);
            }}
            placeholder="Worum geht’s?"
            rows={6}
            required
          />
        </label>

        <div
          style={{
            position: "absolute",
            left: "-9999px",
            height: 0,
            overflow: "hidden",
          }}
          aria-hidden="true"
        >
          <label>
            Website
            <input
              value={contactWebsite}
              onChange={(e) => setContactWebsite(e.target.value)}
              tabIndex={-1}
              autoComplete="off"
            />
          </label>
        </div>

        <div aria-live="polite">
          {status === "success" && (
            <p className="contact-success">✅ Nachricht gesendet. Danke dir!</p>
          )}

          {status === "error" && (
            <p className="contact-error">❌ {errorText}</p>
          )}
        </div>

        <button
          type="submit"
          className="green-button"
          disabled={!isValid || status === "sending"}
          style={{ width: "100%" }}
        >
          {status === "sending" ? "Sende..." : "Nachricht senden"}
        </button>

        <p className="contact-hint">
          Deine Nachricht wird an <strong>info@edens-ernte.app</strong> gesendet.
        </p>
      </form>
    </div>
  );
}

export default ContactForm;